import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const DISMISS_KEY = 'updateBannerDismissedFor';

// Android app only: asks the backend which version is current and, when this installed build is older,
// shows a bar with a link to the Play Store. Does nothing on the web, iOS or when the check fails.
export default function UpdateBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') return undefined;
    let cancelled = false;
    const check = async () => {
      try {
        const [{ build }, res] = await Promise.all([CapApp.getInfo(), axios.get(`${API}/app-version`, { timeout: 8000 })]);
        const installed = parseInt(build, 10);
        const { latest, minimum, storeUrl } = res.data.android || {};
        if (!cancelled && installed && latest && installed < latest) {
          let dismissed = null;
          try { dismissed = localStorage.getItem(DISMISS_KEY); } catch (e) { /* ignore */ }
          const required = !!minimum && installed < minimum;
          if (required || String(dismissed) !== String(latest)) setInfo({ latest, required, storeUrl });
        }
      } catch (e) { /* offline or backend down: no banner */ }
    };
    check();
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { cancelled = true; document.removeEventListener('visibilitychange', onVisible); };
  }, []);

  if (!info) return null;
  const open = () => { window.open(info.storeUrl, '_system'); };
  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(info.latest)); } catch (e) { /* ignore */ }
    setInfo(null);
  };

  return (
    <div role="status" style={{
      position: 'fixed', left: 12, right: 12, bottom: 'calc(12px + env(safe-area-inset-bottom, 0px))', zIndex: 10000,
      display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', borderRadius: 14,
      background: '#1f2a44', color: '#fff', boxShadow: '0 8px 24px rgba(0,0,0,0.35)', fontSize: 14
    }}>
      <span style={{ flex: 1 }}>{info.required ? 'Please update CoachPad to keep using it.' : 'A new version of CoachPad is available.'}</span>
      <button type="button" onClick={open} style={{ background: '#4ade80', color: '#0b2e1a', border: 0, borderRadius: 10, padding: '8px 14px', fontWeight: 700, cursor: 'pointer' }}>Update</button>
      {!info.required && (
        <button type="button" onClick={dismiss} aria-label="Dismiss" style={{ background: 'none', border: 0, color: '#fff', fontSize: 18, cursor: 'pointer', padding: 4 }}>✕</button>
      )}
    </div>
  );
}
